module.exports = __webpack_public_path__ + "static/img/logo_2025.f946b3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_2025.png
// module id = sU6i
// module chunks = 98